// extracted by mini-css-extract-plugin
export default {"button":"AudioPlayer_button__AC-1e","play_pause":"AudioPlayer_play_pause__xav+m"};